import { memo } from 'react'

import { formatTicks } from '../../../util/string.helpers'
import MembershipLevel from '../../staking/MembershipLevel'

const MembershipRequirement = ({ t, id, current, total, completed }) => {
  return (
    <MembershipLevel
      t={t}
      completed={completed}
      id={id}
      title={t('membership.progress-towards-status')}
      label={t('brand:staking.dollar-value-of-staked', {
        value: formatTicks(current),
        total: formatTicks(total)
      })}
      height={10}
      progressTextSx={{ fontWeight: 600 }}
      sx={{ ml: { sm: 5, xs: 0 } }}
    />
  )
}

export default memo(MembershipRequirement)
